export default __webpack_public_path__ + "static/416-0cabc109f17ca6040ae0dd72d8bd4019.gif";